/* eslint-disable */

import { APIClient } from "./_api";
const endpoint = "/Depot";

export function getAll(query) {
  return APIClient.post(`${endpoint}/filter`, query);
}

export function getAllDepot() {
  return APIClient.get(`${endpoint}`);
}
export function edit(values) {
  return APIClient.put(`${endpoint}/${values.id}`, values.data);
}
export function create(value) {
  return APIClient.post(`${endpoint}`, value);
}
export function remove(id) {
  return APIClient.delete(`${endpoint}/${id}`);
}

export function removeTransportationPricing(id) {
  return APIClient.delete(`/TransportationPricing/${id}`);
}

export function addTransportationPricing(values) {
  return APIClient.post(`/TransportationPricing`, values);
}
